// extracted by mini-css-extract-plugin
module.exports = {"box":"_Box_box__wbLCH","header":"_Box_header__-xZpf","intro":"_Box_intro__3my8d"};